import axios from 'axios';

const API_BASE_URL = '';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

export { api };

export const createWishlistItem = async (data) => {
  const response = await api.post('/api/wishlist', data);
  return response.data;
};

export const updateWishlistItem = async (itemId, updates) => {
  const response = await api.put(`/api/wishlist/${itemId}`, updates);
  return response.data;
};

export const deleteWishlistItem = async (id) => {
  const response = await api.delete(`/api/wishlist/${id}`);
  return response.data;
};

export const fetchLists = async () => {
  const response = await api.get('/api/lists');
  return response.data;
};

export const createList = async (listData) => {
  const response = await api.post('/api/lists', listData);
  return response.data;
};

export const updateList = async (listId, listData) => {
  const response = await api.put(`/api/lists/${listId}`, listData);
  return response.data;
};

export const deleteList = async (listId) => {
  const response = await api.delete(`/api/lists/${listId}`);
  return response.data;
};

export const fetchListItems = async (listId) => {
  const response = await api.get(`/api/lists/${listId}`);
  return response.data;
};

export const shareList = async (listId, email) => {
  const response = await api.post(`/api/share/${listId}`, { email });
  return response.data;
};

export const getSharedUsers = async (listId) => {
  const response = await api.get(`/api/share/${listId}/shared-with`);
  return response.data;
};

export const unshareList = async (listId, userId) => {
  const response = await api.delete(`/api/share/${listId}/unshare/${userId}`);
  return response.data;
};

export const getSharedWithMe = async () => {
  const response = await api.get('/api/share/shared-with-me');
  return response.data;
};

export const claimItem = async (listId, itemId, quantity = undefined) => {
  const body = quantity === undefined ? {} : { quantity };
  const response = await api.post(`/api/share/claim/${listId}/${itemId}`, body);
  return response.data;
};

// Public invite link endpoints
export const getPublicList = async (token) => {
  const response = await api.get(`/api/public/invite/${token}`);
  return response.data;
};

export const joinListViaInvite = async (token) => {
  const response = await api.post(`/api/public/invite/${token}/join`);
  return response.data;
};

export const claimItemPublic = async (token, itemId, claimerInfo = {}) => {
  const response = await api.post(
    `/api/public/invite/${token}/claim/${itemId}`,
    claimerInfo
  );
  return response.data;
};

// Invite link management (owner-only)
export const getInviteLinkStatus = async (listId) => {
  const response = await api.get(`/api/share/${listId}/invite-link`);
  return response.data;
};

export const generateInviteLink = async (listId) => {
  const response = await api.post(`/api/share/${listId}/invite-link`);
  return response.data;
};

export const disableInviteLink = async (listId) => {
  const response = await api.delete(`/api/share/${listId}/invite-link`);
  return response.data;
};

export const setAnonymousClaims = async (listId, allow) => {
  const response = await api.put(`/api/share/${listId}/anonymous-claims`, { allow });
  return response.data;
};
